// extracted by mini-css-extract-plugin
export default {"bannerHeaderWrap":"HomePage_bannerHeaderWrap__GMXIA"};